export const DOCUMENT_TYPE = Object.freeze({
  text: {
    title: 'Text',
    icon: 'file-text',
    color: '#ef4444'
  },
  pdf: {
    title: 'PDF',
    icon: 'file-pdf',
    color: '#ef4444'
  },
  video: {
    title: 'Video',
    icon: 'file-image',
    color: '#10b981'
  },
  survey: {
    title: 'Quiz',
    icon: 'file-unknown',
    color: '#d47aff'
  }
})

export const DOCUMENT_SOURCE = Object.freeze({
  subscribed: {
    title: 'Subscribed'
  },
  unsubscribed: {
    title: 'Unsubscribed'
  }
})

export const ASSOCIATE_DOCUMENT_STATUS = Object.freeze({
  accepted: {
    title: 'Accepted',
    color: '#10b981'
  },
  expired: {
    title: 'Expired',
    color: '#f59e0b'
  },
  deprecated: {
    title: 'Incomplete',
    color: '#d4d4d8'
  },
  deleted: {
    title: 'Archived',
    color: '#999999'
  },
  unverified: {
    title: 'Unverified',
    color: '#f59e0b'
  },
  rejected: {
    title: 'Rejected',
    color: '#ef4444'
  }
})

export const ASSOCIATE_DOCUMENT_ORIGIN = Object.freeze({
  associate: {
    title: 'Associate',
    color: '#33dfcf'
  },
  admin: {
    title: 'Admin',
    color: '#2563eb'
  },
  external_project: {
    title: 'External Project',
    color: '#d47aff'
  },
  clipboard: {
    title: 'Clipboard',
    color: '#10b981'
  },
  nurse: {
    title: 'Nurse',
    color: '#E729C1'
  }
})

export const ASSOCIATE_DOCUMENT_SYNC_STATUS = Object.freeze({
  in_progress: {
    title: 'In Progress',
    color: '#2563eb'
  },
  success: {
    title: 'Success',
    color: '#10b981'
  },
  failed: {
    title: 'Failed',
    color: '#ef4444'
  },
  initial: {
    title: 'Initial',
    color: '#999999'
  }
})
